import MentoringMeetingResult from './MentoringMeetingResult.vue';

export default MentoringMeetingResult;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/modal/components/meeting/components/results/index.ts